import { Box, Button } from '@mui/material'

export function IndexControl({
  onIndexUpdate,
  total,
  currentIndex,
}: {
  onIndexUpdate: (i: number) => void
  currentIndex: number
  total: number
}) {
  const doIncr = (inc: number) => {
    const nextIndex = (currentIndex + inc + total) % total
    onIndexUpdate(nextIndex)
  }

  return (
    <Box>
      <Button onClick={() => doIncr(-1)}>{'<'}</Button>
      {`${currentIndex + 1}/${total}`}
      <Button onClick={() => doIncr(1)}>{'>'}</Button>
    </Box>
  )
}
